module.exports = __webpack_public_path__ + "static/media/vinos_tintos.8f20597a.jpg";